import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { LuTrash2, LuX } from "react-icons/lu";
import AccountActionButton from "./AccountActionButton";
import { translateLabel, useTranslationSnapshot } from "./../../translations/runtime";


function DeleteAddressModal({
  address,
  loading = false,
  onClose,
  onConfirm,
  open = false,
}) {
  useTranslationSnapshot();
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !loading) {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [loading, onClose, open]);

  if (!open) return null;
  if (typeof document === "undefined") return null;

  const addressLabel =
    address?.customeLable || address?.label || translateLabel("txt_web_vendor_selected_address_fallback", "selected address");

  return createPortal(
    <div
      className="vendor-delete-address-modal-backdrop"
      onClick={() => {
        if (!loading) onClose?.();
      }}
      role="presentation"
    >
      <div
        aria-label={translateLabel("txt_web_vendor_delete_value1", "Delete {value1}", { value1: addressLabel })}
        aria-modal="true"
        className="vendor-delete-address-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <button
          aria-label={translateLabel("txt_web_vendor_close_delete_address", "Close delete address")}
          className="vendor-delete-address-modal-close"
          disabled={loading}
          onClick={onClose}
          type="button"
        >
          <LuX aria-hidden="true" />
        </button>

        <div className="vendor-delete-address-modal-icon">
          <LuTrash2 aria-hidden="true" />
        </div>

        <h2 className="vendor-delete-address-modal-title">{translateLabel("txt_delete_address", "Delete Address")}</h2>

        <p className="vendor-delete-address-modal-description"> {translateLabel("txt_delete_address_confirmation", "Are you sure you want to delete this address?")}
        </p>

        <div className="vendor-delete-address-modal-actions">
          <AccountActionButton
            color="danger"
            disabled={loading}
            onClick={onConfirm}
            type="button"
            width="fit-content"
          >
            {loading ? "..." : translateLabel("lnk_delete", "Delete")}
          </AccountActionButton>

          <AccountActionButton
            color="dark"
            disabled={loading}
            onClick={onClose}
            type="button"
            width="72px"
          > {translateLabel("txt_end_user_later", "Later")} </AccountActionButton>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default DeleteAddressModal;
